import * as go from 'gojs';

import {
  Model,
  createEmptyModelData,
} from 'src/containers/ProjectDiagram/types/model';

const $ = go.GraphObject.make;

const linkLabelKeysPropertyCallback = (
  data: go.ObjectData,
  update?: go.Key[]
) => {
  if (update) {
    // eslint-disable-next-line no-param-reassign
    data.labelKeys = [...update];
  }
  return [...data.labelKeys.filter(Boolean)];
};

export const createModel = (
  modelSnapshot?: go.ObjectData,
  extraOptions?: Partial<go.GraphLinksModel>
) => {
  const baseModel = $(go.GraphLinksModel, {
    linkKeyProperty: 'key',
    linkLabelKeysProperty: linkLabelKeysPropertyCallback,
    modelData: createEmptyModelData(),
    ...extraOptions,
  });

  const model = (
    modelSnapshot
      ? go.GraphLinksModel.fromJson(
          JSON.stringify(modelSnapshot), // stringify here since passing an object is mutative!
          baseModel
        )
      : baseModel
  ) as Model;

  model.linkLabelKeysProperty = linkLabelKeysPropertyCallback;

  return model;
};
